export * from './OutlinedAlertIcon'
